import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const PartnersService = {
  save: (
    name: string,
    _id?: string,
    // account?: string,
    phone_number?: string,
    email?: string,
    comments?: string,
    status?: boolean,
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}partners`, { _id, account, name, phone_number, email, comments, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}partners/${account}`);
  },
}